<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-12">
        <select-group :validator="$v.selectedGroup" :excludeGroupId="currentGroupId" />
      </div>
    </div>
    <div class="text-left">
      <p-button type="info"
        :loading="isMovingUser"
        @click.native.prevent="moveUser">
        Save
      </p-button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import SelectGroup from '../Inputs/SelectGroup.vue';
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'MoveGroupForm',
  components: {
    SelectGroup
  },
  props: {
    user: Object
  },
  data() {
    return {
      selectedGroup: "",
      isMovingUser: false
    }
  },
  validations: {
    selectedGroup: { required }
  },
  methods: {
    async moveUser() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please select a group.')
        return;
      }

      this.isMovingUser = true;
      const success = await this.$store.dispatch('user/moveUserGroup', {
        user: this.user,
        group: this.selectedGroup
      });
      this.isMovingUser = false;

      if (success) {
        this.resetForm();
        this.$emit('hasUpdate');
      }
    },
    resetForm() {
      this.selectedGroup = "";
      this.$v.$reset();
    }
  },
  computed: {
    currentGroupId() {
      return this.user.group ? this.user.group.id : null;
    }
  }
};
</script>
